// Interpolación lineal de paletas hex. Pensado para gráficos data-driven
// donde el número de series/segmentos es dinámico (StoresDistributionCard
// con N items distintos según el grouping activo del tab).
//
// Filosofía: el theme define ANCHOR colors (--report-chart-segment-*). El
// consumer lee los anchors via getComputedStyle y le pide a este util N
// colores evenly-spaced. Para N <= len(stops) devuelve los stops directos;
// para N > len(stops) interpola.

function hexToRgb(hex) {
    if (typeof hex !== "string") return null;
    const cleaned = hex.replace("#", "");
    if (!/^[0-9a-fA-F]{6}$/.test(cleaned)) return null;
    return {
        r: parseInt(cleaned.slice(0, 2), 16),
        g: parseInt(cleaned.slice(2, 4), 16),
        b: parseInt(cleaned.slice(4, 6), 16),
    };
}

function rgbToHex({ r, g, b }) {
    const h = (v) => v.toString(16).padStart(2, "0");
    return `#${h(r)}${h(g)}${h(b)}`;
}

function lerpChannel(a, b, t) {
    return Math.round(a + (b - a) * t);
}

/**
 * Genera N colores interpolando linealmente entre `from` y `to` (hex strings).
 * - N <= 0 → []
 * - N === 1 → [from]
 * - N >= 2 → evenly-spaced incluyendo ambos extremos
 *
 * Si alguno de los hex no parsea, devuelve N entradas con el sentinel '#000000'
 * para que el consumer pueda detectar el error visualmente.
 */
export function interpolateHexPalette(from, to, n) {
    if (n <= 0) return [];
    if (n === 1) return [from];

    const a = hexToRgb(from);
    const b = hexToRgb(to);
    if (!a || !b) return new Array(n).fill("#000000");

    return Array.from({ length: n }, (_, i) => {
        const t = i / (n - 1);
        return rgbToHex({
            r: lerpChannel(a.r, b.r, t),
            g: lerpChannel(a.g, b.g, t),
            b: lerpChannel(a.b, b.b, t),
        });
    });
}
